// extracted by mini-css-extract-plugin
module.exports = {"navbar":"navbar__navbar__3wS8z","option":"navbar__option__3nQ9P","active":"navbar__active__2PhO0"};